type SelectionRadioOptionProps = {
  checked: boolean
  disabled?: boolean
  label: string
  name: string
  onChange: () => void
}

export function SelectionRadioOption({
  checked,
  disabled = false,
  label,
  name,
  onChange
}: SelectionRadioOptionProps) {
  return (
    <label className="flex cursor-pointer items-center gap-2.5">
      <input
        type="radio"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className="pointer-events-none absolute h-0 w-0 opacity-0"
      />
      <div
        className={`flex h-5 w-5 items-center justify-center rounded-full border-2 transition-colors ${
          checked
            ? 'border-primary bg-white shadow-[0_0_0_3px_rgba(230,83,0,0.15)]'
            : 'border-gray-lighter bg-white'
        }`}
      >
        {checked ? <div className="h-2.5 w-2.5 rounded-full bg-primary" /> : null}
      </div>
      <span className="text-sm text-gray-900">{label}</span>
    </label>
  )
}
